module.exports = __webpack_public_path__ + "static/img/sys-bg-btm.cecfa221.png";